import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useWindowSize } from 'hooks';
import plantilla_lista_invitados from 'assets/excel/Plantilla_lista_invitados.xlsx';

const handleDownloadExcel = () => {
    const link = document.createElement('a');
    link.href = plantilla_lista_invitados;
    link.download = 'Plantilla_lista_invitados.xlsx';

    // Dispara un clic en el enlace para iniciar la descarga.
    document.body.appendChild(link);
    link.click();
  };

const TemplateDownload = () => {
    const [hovered, setHovered] = useState(false);
    return (
        <Button
            id={22}
            block
            variant="secundary"
            onClick={handleDownloadExcel}
            type="button"
            style={{color: hovered?'#ffffff':'#ed0045', fontWeight: '400', width: '100%', ':hover': {color: 'blue'}}}
            className={''}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            >
            Descargar plantilla
        </Button>
    );
};

export default TemplateDownload;